import { useEffect, useState } from 'react';
import { getParameterFromManager } from 'services/Utils';
import { getDocDetails } from './ExtractUtils';

// Archive availability is opt-in; unresolved/invalid configuration is read-only.
export function useArchivedQaActions(isArchived) {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let current = true;
    setEnabled(false);
    if (isArchived) {
      getParameterFromManager('DATA_ARCHIVE_CONFIG').then(config => {
        if (current) setEnabled(config?.archivedQa?.enabled === true);
      }).catch(() => {});
    }
    return () => { current = false; };
  }, [isArchived]);
  const resolve = async document => {
    if (!isArchived) return document;
    const result = await getDocDetails(document, true);
    if (!result?.document_id || result.error) throw new Error(result?.error || 'Archived QA is unavailable. Reload the submission.');
    return result;
  };
  return { enabled, resolve };
}
